import { useEffect, useState } from 'react';

// Types each word, pauses, deletes it and moves on to the next one.
export default function useTypewriter(words) {
    const [typed, setTyped] = useState('');

    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            setTyped(words[0]);
            return;
        }

        let w = 0, c = 0, del = false, timer;
        const tick = () => {
            const word = words[w];
            c += del ? -1 : 1;
            setTyped(word.slice(0, c));
            let wait = del ? 40 : 85 + Math.random() * 60;
            if (!del && c === word.length) { del = true; wait = 1800; }
            else if (del && c === 0) { del = false; w = (w + 1) % words.length; wait = 400; }
            timer = setTimeout(tick, wait);
        };
        tick();
        return () => clearTimeout(timer);
    }, [words]);

    return typed;
}
